'use client'

import { useState } from 'react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import type { MobileNavProps } from './types'

export default function MobileNav({ links, className }: MobileNavProps) {
	const [isOpen, setIsOpen] = useState(false)

	const closeMenu = () => setIsOpen(false)

	return (
		<div className={className}>
			<Button
				type='button'
				variant='ghost'
				className='h-auto px-3 py-2'
				aria-label='Menü öffnen'
				aria-controls='mobile-menu'
				aria-expanded={isOpen}
				onClick={() => setIsOpen(true)}
			>
				Menü
			</Button>

			{isOpen && (
				<div
					id='mobile-menu'
					className='animate-fade-in-left fixed inset-0 z-50 flex flex-col overflow-y-auto bg-(--color-frost) p-6'
				>
					<div className='flex justify-end'>
						<Button
							type='button'
							variant='ghost'
							className='h-auto px-3 py-2'
							aria-label='Menü schließen'
							onClick={closeMenu}
						>
							Schließen
						</Button>
					</div>

					<ul
						className='mt-6 flex flex-col gap-8'
						role='list'
					>
						{links.map((link) => {
							const hasSubitems = Boolean(link.subitems?.length)

							return (
								<li
									key={link.url ?? link.text}
									className='flex flex-col gap-3'
								>
									{link.url ? (
										<Link
											href={link.url}
											className='text-2xl'
											onClick={closeMenu}
										>
											{link.text}
										</Link>
									) : (
										<span className='text-2xl'>{link.text}</span>
									)}

									{hasSubitems && (
										<ul
											className='flex flex-col gap-2 pl-4'
											role='list'
											aria-label={`Unterseiten von ${link.text}`}
										>
											{link.subitems?.map((subitem) => (
												<li key={subitem.url}>
													<Link
														href={subitem.url}
														className='block text-lg'
														onClick={closeMenu}
													>
														{subitem.text}
													</Link>
												</li>
											))}
										</ul>
									)}
								</li>
							)
						})}
					</ul>
				</div>
			)}
		</div>
	)
}
